module.exports = __webpack_public_path__ + "img/sixpackcarrier41.6d5882f1.jpg";